import neww from "../../assets/newShipment.png";
import readyToShip from "../../assets/readytoship.png";
import shipped from "../../assets/shipped.png";
import outfordelivery from "../../assets/outofdel.png";
import delivered from "../../assets/delivered.png";
import returnRequested from "../../assets/returnedreq.png";
import returned from "../../assets/returned.png";
import cancelled from "../../assets/cancell.png";
import undelivered from "../../assets/unavailable.png";
import damaged from "../../assets/damage.png";

export const ShipmentType = [
  { id: 1, value: "Manual" },
  { id: 2, value: "Redemption" },
  { id: 4, value: "Campaign" },
  { id: 5, value: "Swagstore" },
  { id: 6, value: "Shopify" },
  { id: 7, value: "Partner" },
];

export enum ShipmentStatusEnum {
  NEW = 1,
  READY_TO_SHIP = 2,
  SHIPPED = 3,
  OUT_FOR_DELIVERY = 4,
  DELIVERED = 5,
  RETURN_REQUESTED = 6,
  RETURNED = 7,
  CANCELLED = 8,
  UNDELIVERED = 9,
  DAMAGED = 10,
}

export const ShipmentStatus = [
  { id: 1, value: "New", icon: neww },
  { id: 2, value: "Ready To Ship", icon: readyToShip },
  { id: 3, value: "Shipped", icon: shipped },
  { id: 4, value: "Out for delivery", icon: outfordelivery },
  { id: 5, value: "Delivered", icon: delivered },
  { id: 6, value: "Return Requested", icon: returnRequested },
  { id: 7, value: "Returned", icon: returned },
  { id: 8, value: "Cancelled", icon: cancelled },
  { id: 9, value: "Undelivered", icon: undelivered },
  { id: 10, value: "Damaged", icon: damaged },
];

export interface ShipmentStatusFilter {
  id: number;
  label: string;
  count: number;
  icon: string;
}
